const Plugin = require("common/Plugin");
const InfoLauncher = require("info/InfoLauncher");
const postal = require("postal");

function InfoPlugin() {
    const self = this;
    let $menuItem;

    this.start = function() {
        const launcher = new InfoLauncher();

        self.addOptionsMenuEntry(
            $.t("common::info.title"),
            launcher.launch,
            15).then(function(entry) {
            $menuItem = entry;
        });

        function toggleMenuEntry(event, serverConfig) {
            if ($menuItem && $menuItem.toggle) {
                $menuItem.toggle(serverConfig && serverConfig.infoFileName !== "");
            }
        }

        $(document).on("connectionsuccessful", toggleMenuEntry);
        $(document).on("staterestored", toggleMenuEntry);

        postal.channel("Electron").subscribe("show-info", launcher.launch);
    };
}

InfoPlugin.prototype = Plugin;

module.exports = InfoPlugin;